export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Features"])},
        "default_feature": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Default"])},
        "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This feature is not available on containers"])}
      },
      "fr": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["traits"])},
        "default_feature": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Défaut"])},
        "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cette fonctionnalité n'est pas disponible sur les conteneurs"])}
      }
    }
  })
}